import { parseListInput } from "../../../core/utils/parse-list-input";
import { STUDY_TYPE_OPTIONS, yesNo } from "../../quick-filter/ExtraFilters";

/**
 * Faturalandırma grid'inin "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde
 * (ReportBillingFilter) duran filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır.
 */
export const REPORT_BILLING_EXTRA_FIELDS = [
    { key: 'hospitalGroupIdList', label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [], permissions: ['HOSPITAL_GROUP_FILTER'] },
    { key: 'hospitalIdList', label: 'Hospital Name', kind: 'lookup', source: 'hospitals', empty: [] },
    { key: 'accessionNumber', label: 'Accession No', kind: 'text', empty: undefined },
    {
        // Mutabakat listesinden yapıştırılan çoklu acc no; sol paneldeki ayrıştırmanın aynısı (bkz. ReportBillingFilter.toFilter).
        key: 'accessionNumberList',
        label: 'Accession Numbers',
        kind: 'list',
        empty: [],
        toFilter: (value) => ({ accessionNumberList: parseListInput(value) }),
    },
    { key: 'patientId', label: 'Patient Id', kind: 'text', empty: undefined },
    { key: 'patientName', label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'studyTypeList', label: 'Study Type', kind: 'select', multiple: true, options: STUDY_TYPE_OPTIONS, empty: [] },
    { key: 'isHbysTransfer', label: 'Hbys Transfer Status', kind: 'select', options: yesNo('Transferred', 'Not Transferred'), empty: null },
    { key: 'institutions', label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
];
